//import "whatwg-fetch";
//import { fetch as fetchPolyfill } from "whatwg-fetch";

import { Translation as Tr } from "./Translation.js";
import { Top } from "./Top.js";

var HodnoceniObchodu = {
  defaultOpt: {
    // Kolik hodnocení se má načíst, uložit do cache a vypsat.
    max: 4,

    // Základ cache key.
    // Finální cache key se doplní o jazyk, např.:
    // ldz_cache_hodnoceni_obchodu_cs
    cacheKey: "ldz_cache_hodnoceni_obchodu",

    // Platnost cache: 24 hodin.
    cacheTtl: 24 * 60 * 60 * 1000,

    // URL se normálně skládá automaticky z překladů.
    // Pokud budeš chtít, můžeš ji předat ručně přes opt.url.
    url: "",
  },

  opt: {},

  /**
   * Hlavní veřejná funkce.
   *
   * Vrací Promise.
   *
   * Nejdřív zkusí cache.
   * Pokud cache neexistuje nebo je stará, stáhne stránku hodnocení.
   * Ze staženého HTML vytáhne:
   * - HTML hodnocení
   * - score z .rate-average
   * - hvězdičky z .rate-star-wrap
   * - počet hodnocení ze .stars-label
   *
   * Použití:
   *
   * HodnoceniObchodu.ziskejHodnoceni({
   *   max: 3,
   * }).then((data) => {
   *   console.log(data.kod);
   *   console.log(data.score);
   *   console.log(data.hvezdy);
   *   console.log(data.pocet);
   * });
   */
  ziskejHodnoceni: function(opt) {
    Lc.f("HodnoceniObchodu:ziskejHodnoceni");

    // Pozor: neděláme _.extend(this.defaultOpt, opt),
    // protože by se tím měnil defaultOpt natrvalo.
    this.opt = _.extend({}, this.defaultOpt, opt || {});

    // Jazyk z Top.jazyk, fallback cs.
    this.opt.jazyk = Top && Top.jazyk ? Top.jazyk : "cs";

    // Cache bude oddělená pro každý jazyk.
    this.opt.cacheKey = this.opt.cacheKey + "_" + this.opt.jazyk;

    // URL hodnocení podle aktuálního jazyka.
    if (!this.opt.url) {
      this.opt.url =
        window.location.origin + Tr.l("url_hodnoceni_obchodu") + "?ldzFetch";
    }

    Lc.log("HodnoceniObchodu opt", this.opt);

    // 1) Nejdřív zkusíme načíst platnou cache.
    var cacheData = this.cacheNacti(false);

    if (cacheData) {
      Lc.log("HodnoceniObchodu cache hit", cacheData);
      return Promise.resolve(cacheData);
    }

    // 2) Cache není, stahujeme stránku.
    return fetch(this.opt.url)
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        return HodnoceniObchodu.prms_getContainer(html);
      })
      .then(function(data) {
        if (data && data.kod) {
          HodnoceniObchodu.cacheUloz(data);
        }

        return data;
      })
      .catch((error) => {
        Lc.ctch(error);

        // 3) Když fetch selže, zkusíme vrátit i prošlou cache.
        // Lepší starší hodnocení než prázdný blok.
        var staraCache = HodnoceniObchodu.cacheNacti(true);

        if (staraCache) {
          Lc.log("HodnoceniObchodu stara cache", staraCache);
          return staraCache;
        }

        return null;
      });
  },

  /**
   * Zpracuje stažené HTML stránky hodnocení.
   *
   * Vrací Promise kvůli zachování stylu původního kódu.
   *
   * Výsledek:
   * {
   *   kod: "... HTML s .votes-wrap ...",
   *   score: "5,0",
   *   hvezdy: "... HTML s hvězdičkami ...",
   *   pocetText: "714 hodnocení",
   *   pocet: "714"
   * }
   */
  prms_getContainer: function(html) {
    Lc.f("HodnoceniObchodu:prms_getContainer");

    var opt = this.opt;

    return new Promise(function(resolve) {
      Lc.promise("Promise html");

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");

      var votesWrap = doc.querySelector(".votes-wrap");

      if (!votesWrap) {
        resolve(null);
        return;
      }

      var $doc = $(doc);
      var $votesWrap = $(votesWrap);

      // Score, např. 5,0.
      var score = $.trim(
        $doc
          .find(".rate-average")
          .first()
          .text(),
      );

      // Hvězdičky - ukládáme jako HTML, protože se mohou hodit pro výpis nahoře.
      var hvezdy = "";

      var $hvezdy = $doc.find(".rate-star-wrap").first();

      if ($hvezdy.length) {
        hvezdy = $("<div></div>")
          .append($hvezdy.clone())
          .html();
      }

      // Text počtu hodnocení, např. "714 hodnocení".
      var pocetText = $.trim(
        $doc
          .find(".stars-label")
          .first()
          .text(),
      );

      // Jen číslo, např. "714".
      var pocet = pocetText.replace(/[^\d]/g, "");

      // HTML s jednotlivými recenzemi.
      var kod = '<div class="votes-wrap">';
      var x = 0;

      $votesWrap.find("> .vote-wrap").each(function() {
        x++;

        var $tento = $(this);

        var kus = $("<div></div>")
          .append($tento.eq(0).clone())
          .html();

        kod += kus;

        if (x >= opt.max) {
          return false;
        }
      });

      kod += "</div>";

      var data = {
        kod: kod,
        score: score,
        hvezdy: hvezdy,
        pocetText: pocetText,
        pocet: pocet,
      };

      Lc.log("HodnoceniObchodu data", data);

      resolve(data);
    });
  },

  /**
   * Načtení cache z localStorage.
   *
   * vratitIProslouCache:
   * - false = vrátí pouze platnou cache
   * - true  = vrátí i starou cache, používá se při chybě fetch
   */
  cacheNacti: function(vratitIProslouCache) {
    var raw = localStorage.getItem(this.opt.cacheKey);

    if (!raw) {
      return null;
    }

    var data;

    try {
      data = JSON.parse(raw);
    } catch (e) {
      return null;
    }

    if (!data || !data.time || !data.kod) {
      return null;
    }

    if (vratitIProslouCache) {
      return data;
    }

    var ted = new Date().getTime();

    if (ted - data.time > this.opt.cacheTtl) {
      return null;
    }

    return data;
  },

  /**
   * Uložení cache do localStorage.
   */
  cacheUloz: function(data) {
    if (!data || !data.kod) {
      return;
    }

    data.time = new Date().getTime();

    try {
      localStorage.setItem(this.opt.cacheKey, JSON.stringify(data));
    } catch (e) {
      // localStorage může být plný nebo zakázaný.
      // Nevadí, stránka jen pojede bez cache.
    }
  },

  /**
   * Smazání cache pro aktuální jazyk.
   *
   * Hodí se při ladění:
   * HodnoceniObchodu.cacheSmaz();
   */
  cacheSmaz: function() {
    localStorage.removeItem(this.opt.cacheKey);
  },

  _init: function() {},
};

HodnoceniObchodu._init();

export { HodnoceniObchodu };
